exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".customInvalid {\n  border: 1px solid red;\n  border-radius: 3px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/backend/src/app/shared/components/select-vna-client/select-vna-client.component.scss
// module id = ../../../../../src/app/shared/components/select-vna-client/select-vna-client.component.scss
// module chunks = main